import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-blue-50 flex items-center justify-center px-4">
      <div className="max-w-lg mx-auto text-center">
        {/* Ilustración deportiva creativa */}
        <div className="mb-8">
          <div className="relative">
            {/* Pelota de fútbol animada */}
            <div className="w-32 h-32 mx-auto mb-4 relative">
              <div className="w-32 h-32 rounded-full bg-white border-4 border-gray-800 flex items-center justify-center shadow-lg animate-bounce">
                <div className="grid grid-cols-3 gap-1">
                  <div className="w-3 h-3 bg-gray-800 rounded-full"></div>
                  <div className="w-3 h-3 bg-white"></div>
                  <div className="w-3 h-3 bg-gray-800 rounded-full"></div>
                  <div className="w-3 h-3 bg-white"></div>
                  <div className="w-3 h-3 bg-gray-800 rounded-full"></div>
                  <div className="w-3 h-3 bg-white"></div>
                  <div className="w-3 h-3 bg-gray-800 rounded-full"></div>
                  <div className="w-3 h-3 bg-white"></div>
                  <div className="w-3 h-3 bg-gray-800 rounded-full"></div>
                </div>
              </div>
            </div>

            {/* Número 404 grande */}
            <div className="text-8xl font-black text-gray-200 absolute top-16 left-1/2 transform -translate-x-1/2 -z-10">
              404
            </div>
          </div>
        </div>

        {/* Contenido */}
        <div className="space-y-6">
          <div>
            <h1 className="text-4xl font-bold text-gray-900 mb-2">
              {t('notFound.title')}
            </h1>
            <p className="text-xl text-gray-600">
              {t('notFound.subtitle')}
            </p>
          </div>

          <div className="space-y-4">
            <p className="text-gray-500">
              {t('notFound.description')}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors duration-200"
              >
                <svg className="mr-2 -ml-1 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                {t('notFound.backHome')}
              </Link>

              <Link
                to="/support"
                className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors duration-200"
              >
                <svg className="mr-2 -ml-1 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                {t('notFound.getHelp')}
              </Link>
            </div>
          </div>

          {/* Elementos deportivos decorativos */}
          <div className="flex justify-center space-x-8 mt-12 opacity-30">
            <div className="text-4xl animate-pulse">⚽</div>
            <div className="text-4xl animate-pulse delay-75">🏀</div>
            <div className="text-4xl animate-pulse delay-150">🎾</div>
            <div className="text-4xl animate-pulse delay-225">🏐</div>
          </div>

          {/* Mensaje motivacional */}
          <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-sm text-blue-700">
              <span className="font-semibold">{t('notFound.tip')}</span> {t('notFound.tipDescription')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;